import * as Yup from 'yup';
import { otpValidation } from "helpers/validationHelper";

const validation = Yup.object({
    otp: otpValidation
});

export default validation;